import * as z from 'zod';

export const holidaysSchema = z.record(z.string(), z.string());
